import { useHead } from '@unhead/vue'

export const customHeadFactory = () => {
  return useHead({
    title: `Miljn`,
    meta: [],
  })
}
